import { CellSelectionOptions, SideBarDef, StatusPanelDef } from 'ag-grid-enterprise'

/**
 * Cell selection configuration for fill handle
 */
export const getCellSelectionConfig = (): CellSelectionOptions => ({
  handle: {
    mode: 'fill' as const
  }
})

/**
 * Status bar configuration with standard AG Grid components
 */
export const getStatusBarConfig = (): { statusPanels: StatusPanelDef[] } => ({
  statusPanels: [
    { statusPanel: 'agTotalAndFilteredRowCountComponent' },
    { statusPanel: 'agTotalRowCountComponent' },
    { statusPanel: 'agFilteredRowCountComponent' },
    { statusPanel: 'agSelectedRowCountComponent' },
    { statusPanel: 'agAggregationComponent' }
  ]
})

/**
 * Side bar with just the columns tool panel (show/hide, pin, reorder columns).
 * Row grouping/values/pivot are suppressed since these grids don't use pivoting.
 */
export const getColumnsSideBarConfig = (): SideBarDef => ({
  toolPanels: [
    {
      id: 'columns',
      labelDefault: 'Columns',
      labelKey: 'columns',
      iconKey: 'columns',
      toolPanel: 'agColumnsToolPanel',
      toolPanelParams: {
        suppressRowGroups: true,
        suppressValues: true,
        suppressPivots: true,
        suppressPivotMode: true
      }
    }
  ],
  defaultToolPanel: ''
})
